import theme, {themeColors} from '../../theme/Theme';

export const useSideMenuStyles = () => ({
  item: {
    paddingLeft: theme.spacing(1),
    borderRadius: 8,
    padding: 0,
    backgroundColor: themeColors.white,
    '&:hover': {
      color: theme.palette.secondary.main,
    },
    '&.active': {
      color: themeColors.coral,
      backgroundColor: theme.palette.background.paper,
    },
    color: theme.palette.text.primary,
  },
  activeItem: {
    backgroundColor: `rgba(34, 56, 79, 0.07)`,
    color: 'rgba(34, 56, 79, 1)',
  },
  drawerLink: {
    backgroundColor: 'transparent !important',
  },
  drawer: {
    flexShrink: 0,
  },
  accordion: {
    '& .Mui-expanded': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  accordionSummary: {
    margin: 0,
    height: 34,
    minHeight: 'auto',
    paddingLeft: 8,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    '& .MuiAccordionSummaryExpandIcon': {
      padding: 4,
    },
    '&.MuiExpanded': {
      paddingLeft: 8,
      margin: 0,
      minHeight: 'auto',
      marginBottom: 2,
    },
  },
  accordionDetails: {
    padding: 0,
    paddingLeft: 12,
    flexDirection: 'column',
    paddingBottom: 10,
  },
});
